/* ============================================================
   IVANDE AI CLIENT
   assets/ivande-ai.js

   Centralized client for every AI touchpoint that calls the
   middleware at api.ivande.com. Loaded as a global on every page
   via theme.liquid. Consumers access it via window.IvandeAI.

   Base URL is set from theme settings (settings.ai_base_url),
   written to window.IVANDE_AI_BASE in the head before this file
   loads. Allows the founder to point at staging vs. production
   from the theme editor without a code change.

   Every method:
     - Times out after IVANDE_AI_TIMEOUT_MS (default 6s)
     - Returns { ok: true, data } on success
     - Returns { ok: false, error: <string> } on failure
     - Never throws, consumers can safely render a fallback
   ============================================================ */

(function () {
  if (window.IvandeAI) return; // idempotent

  const BASE = (window.IVANDE_AI_BASE || 'https://api.ivande.com').replace(/\/+$/, '');
  const TIMEOUT_MS = window.IVANDE_AI_TIMEOUT_MS || 6000;

  function withTimeout(promise, ms) {
    return Promise.race([
      promise,
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('timeout')), ms)
      ),
    ]);
  }

  async function post(path, payload) {
    try {
      const res = await withTimeout(
        fetch(BASE + path, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload || {}),
        }),
        TIMEOUT_MS
      );
      if (!res.ok) {
        return { ok: false, error: 'http_' + res.status };
      }
      const data = await res.json();
      return { ok: true, data };
    } catch (err) {
      return { ok: false, error: (err && err.message) || 'network' };
    }
  }

  /**
   * Size recommendation.
   * POST /api/ai/size
   * @param {object} payload { sku, height_ft, height_in, weight, fit }
   * @returns {{ok:true, data:{size, explanation, confidence}} | {ok:false, error}}
   */
  async function getSize(payload) {
    return post('/api/ai/size', payload);
  }

  /**
   * Style quiz archetype classification.
   * POST /api/ai/quiz
   * @param {object[]} answers, array of { question_id, option_value }
   * @returns {{ok:true, data:{archetype, welcome, products}} | {ok:false, error}}
   */
  async function classifyArchetype(answers) {
    return post('/api/ai/quiz', { answers });
  }

  /**
   * Urgency note.
   * POST /api/ai/urgency
   * @param {object} payload { sku, remaining, archetype }
   * @returns {{ok:true, data:{note}} | {ok:false, error}}
   */
  async function getUrgency(payload) {
    return post('/api/ai/urgency', payload);
  }

  window.IvandeAI = { getSize, classifyArchetype, getUrgency, BASE };
})();
